module.exports = __webpack_public_path__ + "static/img/classImage.70b0985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pocAiClassroom/classImage.png
// module id = Nffc
// module chunks = 4